import styled from "styled-components";
import { getSafe } from "../../../utils";
import Card from "../index";
const Wrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 90px;
  text-align: center;
  margin-bottom: 2rem;
`;

const Title = styled.h3`
  font-family: ${({ theme }) => theme.fonts.sofia};
  font-style: normal;
  font-weight: 500;
  font-size: 2.5rem;
  line-height: 100%;
  width: ${(props) => (props.grid ? "80%" : "25rem")};
  color: ${({ theme }) => theme.white};
  margin: 0 auto;
  @media (max-width: 768px) {
    font-size: 16px !important;
    margin-top: 0px !important;
    width: 80%;
  }
`;

function CardTitle({ children, grid, slide, city }) {
  return (
    <Wrapper grid={grid}>
      {city && (
        <Card.UpperText city={city}>
          {getSafe(() => slide.contact.address.city)}
        </Card.UpperText>
      )}
      <Title grid={grid}>
        {getSafe(() =>
          children.length > 60 ? children.substr(0, 60) + "..." : children
        )}
      </Title>
    </Wrapper>
  );
}

export default CardTitle;
